module.exports = __webpack_public_path__ + "static/media/machine-learning.3d2d96ed.jpg";